import {
  ApplicationFormValues,
  ApplicationFormInitialValues,
} from "../../store/InitialStore";
import * as types from "../../actions/ActionTypes";
export default function ApplicationForm(state = ApplicationFormValues, action) {
  const {
    type,
    payload,
    documentIndex,
    elementId,
    documentId,
    stepValue,
  } = action;

  switch (type) {
    case types.GOTO_NEXT_STEP:
      return {
        ...state,
        currentStep: parseInt(payload) + 1,
      };
    case types.GOTO_PREVIOUS_STEP:
      return {
        ...state,
        currentStep: parseInt(payload) - 1,
      };
    case types.GOTO_SELECTED_STEP:
      return {
        ...state,
        currentStep: parseInt(payload),
      };
    case types.SET_BASICFORM_VALUES:
      return {
        ...state,
        currentStep: stepValue,
        step1: payload,
      };
    case types.APPLICATION_STEP_ONE_SET_FIELD_VALUES:
      const { step1 = {} } = state;
      return {
        ...state,
        step1: { ...step1, ...payload },
      };

    case types.SET_APPLICATION_PLACEHOLDERS:
      const { step2 } = state;
      return {
        ...state,
        needResetForm: false,
        step2: {
          ...step2,
          applicationValues: payload,
        },
      };
    case types.SET_APPLICATION_VALUES:
      
      const {
        step2: step2Data,
        step2: { applicationValues = [] },
      } = state;

      let currentElements = applicationValues[documentIndex].elements;
     
      let updateElementIndex = currentElements.findIndex(
        (element) => element.elementId === elementId
      );

      currentElements[updateElementIndex] = payload;
    
      // return state;
      //  let newApplicationdata = [...applicationValues];
      // newApplicationdata[documentIndex].elements = currentElements;
      // console.log(
      //   {
      //     ...state,
      //     step2: {
      //       ...step2Data,
      //       applicationValues,
      //     },
      //   },
      //   "new va;"
      // );
      return {
        ...state,
        step2: {
          ...step2Data,
          applicationValues,
        },
      };
    case types.SET_PDF_BLOB:
      return {
        ...state,
        base64Pdf: payload,
      };
    case types.SET_ADDITIONAL_DOCUMENT_URL:
      const {
        step1: step1Data,
        step1: { additionalDocuments },
      } = state;
      additionalDocuments.find(
        (element) => element.documentId === documentId
      ).documentURL = payload;

      return {
        ...state,
        step1: {
          ...step1Data,
          additionalDocuments,
        },
      };
    case types.RESET_APPLICATION_FORM:
      const {
        step2: { applicationValues: oldData = [] },
      } = state;
      return {
        ...ApplicationFormInitialValues,
        needResetForm: true,
        step2: {
          applicationValues: oldData,
        },
      };
    case types.SET_CONVENIENCE_FEE:
      const { step1: step1Data2 } = state;
      
      return {
        ...state,
        step1: {
          ...step1Data2,
          convenienceFee: payload,
        },
      };
    case types.SAVE_BASE64_WEBFORM:
      return {
        ...state,
        base64WebForm: payload,
      };
    default:
      return state;
  }
}
